import React from 'react';
import HeroArea from '../components/project/ProjectHero';
import NextProjectButton from '../components/project/NextProjectButton';
import ProjectIntro from '../components/project/ProjectIntro';
import { IProjectList } from '../components/project/ProjectList';
import ProjectShowCaseDesktop, { IDesktopScreen } from '../components/project/ProjectShowcaseDesktop';
import ProjectShowCaseMobile, { IScreenMobile } from '../components/project/ProjectShowcaseMobile';

import hero from '../assets/images/cover-image_stibbel.jpg'
import lazy from '../assets/compressed-images/cover-image_stibbel.png'
import MobileOverview from '../assets/images/stibbel/stibbel-mobile_overview.png';
import MobileProjectStart from '../assets/images/stibbel/stibbel-mobile_project-start.png';
import MobileMapOverview from '../assets/images/stibbel/stibbel-mobile_map-overview.png';
import MobileMapProxy from '../assets/images/stibbel/stibbel-mobile_map-proximity.png';
import MobileMapPreview from '../assets/images/stibbel/stibbel-mobile_map-location-preview.png';
import MobileLocationFound from '../assets/images/stibbel/stibbel-mobile_location-gevonden.jpg';
import MobileLocationDetail from '../assets/images/stibbel/stibbel-mobile_location-detail.png';

import DesktopBeaconOverview from '../assets/images/stibbel/stibbel-desktop_beacon-overview.png';
import DesktopProjects from '../assets/images/stibbel/stibbel-desktop_main-start.png';
import DesktopMapGoogle from '../assets/images/stibbel/stibbel-desktop_map-google.png';
import DesktopLocation from '../assets/images/stibbel/stibbel-desktop_location.png';
import DesktopOrder from '../assets/images/stibbel/stibbel-desktop_order-beacons.png';
import IShowCaseTypes from '../models/IShowCaseTypes';
import CloseProject from 'components/shared/CloseProject';



function Stibbel() {
    const title: string = "Stibbel";
    const summary: string = "A CMS to create and manage your own location based apps with GPS and beacons.";

    const projectLists: Array<IProjectList> = [{
        nameOfList: 'Category',
        items: ["Design", "Mobile", "Desktop", "Front-end", "UX Design", "Branding"]
    },
    {
        nameOfList: 'Technology',
        items: ["Angular 5", "Sass", "Axure", "Invision", "Sketch", "Adobe Illustrator"]
    }];

    const mobileOverview: IScreenMobile = { type: IShowCaseTypes.mobile, src: MobileOverview, alt: 'Stibbel app overview of projects' };
    const mobileProjectStart: IScreenMobile = { type: IShowCaseTypes.mobile, src: MobileProjectStart, alt: 'Stibbel app start project' };
    const mobileMapOverview: IScreenMobile = { type: IShowCaseTypes.mobile, src: MobileMapOverview, alt: 'Stibbel app map overview' };
    const mobileMapProxy: IScreenMobile = { type: IShowCaseTypes.mobile, src: MobileMapProxy, alt: 'Stibbel app map view with proximity locations' };
    const mobileMapPreview: IScreenMobile = { type: IShowCaseTypes.mobile, src: MobileMapPreview, alt: 'Stibbel app map location preview' };
    const mobileLocationDetail: IScreenMobile = { type: IShowCaseTypes.mobile, src: MobileLocationDetail, alt: 'Stibbel app map location preview' };
    const mobileLocationFound: IScreenMobile = { type: IShowCaseTypes.mobile, src: MobileLocationFound, alt: 'Stibbel app map location preview' };

    const desktopProjects: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "www.stibbel.nl/myprojects", src: DesktopProjects, alt: 'Stibbel CMS overview of all your excising projects' };
    const desktopMapGoogle: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "www.stibbel.nl/project/wandelbosgroenendaal", src: DesktopMapGoogle, alt: 'Stibbel CMS location overview of your project' };
    const desktopLocationDetail: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "www.stibbel.nl/project/wandelbosgroenendaal/hoofdingang", src: DesktopLocation, alt: 'Stibbel CMS creating a detail page for a location' };
    const desktopBeaconOverview: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "www.stibbel.nl/beacons", src: DesktopBeaconOverview, alt: 'Stibbel CMS overview of beacons added to system' };
    const desktopOrder: IDesktopScreen = { type: IShowCaseTypes.desktop, fakeUrl: "www.stibbel.nl/beacons/order", src: DesktopOrder, alt: 'Stibbel CMS ordering beacons' };


    const app1: Array<IScreenMobile> = [mobileOverview, mobileProjectStart];
    const app2: Array<IScreenMobile> = [mobileMapOverview, mobileMapProxy, mobileMapPreview];
    const app3: Array<IScreenMobile> = [mobileLocationDetail, mobileLocationFound];
    const cms1: IDesktopScreen = desktopProjects;
    const cms2: IDesktopScreen = desktopMapGoogle;
    const cms3: IDesktopScreen = desktopLocationDetail;
    const cms4: IDesktopScreen = desktopBeaconOverview;
    const cms5: IDesktopScreen = desktopOrder;

    return (
        <>
            <CloseProject />
            <HeroArea hero={hero} placeholder={lazy} />
            <ProjectIntro summary={summary} projectLists={projectLists} title={title} />

            <ProjectShowCaseMobile screens={app1} />
            <ProjectShowCaseMobile screens={app2} />
            <ProjectShowCaseMobile screens={app3} />
            <ProjectShowCaseDesktop screen={cms1} />
            <ProjectShowCaseDesktop screen={cms2} />
            <ProjectShowCaseDesktop screen={cms3} />
            <ProjectShowCaseDesktop screen={cms4} />
            <ProjectShowCaseDesktop screen={cms5} />

            <NextProjectButton />

        </>
    );
};

export default Stibbel